<template>
  <div :class="$style['pt-system-customer-form']">
    <pt-page-title :title="isEdit?'编辑用户':'新建用户'"></pt-page-title>
    <pt-sub-title title="用户基本信息"></pt-sub-title>
    <table :class="$style['role-customer-basic-message']">
      <pt-form-list-item label="用户名：" required>
        <wt-input v-model="formValue.username" v-validate="isEdit ? 'required' :'required|username'" data-vv-as="用户名" placeholder="请填写用户名"></wt-input>
        <!-- <span :class="$style['edit-password-text']">用户名只能由小写字母，数字或下划线组成</span> -->
      </pt-form-list-item>
      <pt-form-list-item label="选择所属单位：" required>
        <primary-organization-selector  data-vv-as="选择所属单位" v-validate="'required'" v-model="formValue.organizationId"></primary-organization-selector>
      </pt-form-list-item>
      <pt-form-list-item label="密码："  :required="isEdit?false:true" >
        <el-input type="password"  v-model="formValue.password"  data-vv-as="密码" v-validate="isEdit ? '':'required|password'" placeholder="请填写密码"></el-input>
        <span :class="$style['edit-password-text']" v-if="isEdit">如需修改密码，则在此输入新密码。不填则默认为不修改密码</span>
        <span :class="$style['edit-password-text']" v-else>请填写6-15位密码</span>
      </pt-form-list-item>
      <pt-form-list-item label="请再次输入密码：" :required="isEdit?false:true">
        <el-input type="password" v-model="formValue.checkPass"  data-vv-as="确认密码" v-validate="isEdit ? '':'required|password'" placeholder="请再次填写密码"></el-input>
        <!-- <span :class="$style['edit-password-text']" v-if="isEdit">如需修改密码，则在此输入新密码。不填则默认为不修改密码</span>
        <span :class="$style['edit-password-text']" v-else>请填写6-15位密码</span> -->
      </pt-form-list-item>
      <pt-form-list-item label="姓名：" required>
        <wt-input v-model="formValue.firstName"  data-vv-as="姓名" v-validate="'required'" placeholder="请填写姓名"></wt-input>
      </pt-form-list-item>
      <pt-form-list-item label="性别：">
        <el-radio-group  data-vv-as="性别" v-validate="'required'" v-model="formValue.gender">
          <el-radio label="MALE">男</el-radio>
          <el-radio label="FEMALE">女</el-radio>
        </el-radio-group>
      </pt-form-list-item>
      <pt-form-list-item label="手机号：" required>
        <wt-input v-model="formValue.mobile" data-vv-as="手机号" v-validate="'required|phone'" placeholder="请填写手机号"></wt-input>
      </pt-form-list-item>
      <!-- <pt-form-list-item label="所属客户：" required >
           <wt-input v-model="formValue.mobile"  data-vv-as="所属客户"  v-validate="'required|phone'"></wt-input>
        </pt-form-list-item> -->
      <pt-form-list-item label="角色：" required>
        <wt-selector :class="$style['org-select']" data-vv-as="角色" v-validate="'required'" :options="rolesList" :props="roleProp" v-model="formValue.roles" multiple></wt-selector>
      </pt-form-list-item>
      <pt-form-list-item label="科室：" required>
        <wt-selector :class="$style['org-select']" data-vv-as="科室" v-validate="'required'" :options="offices" v-model="formValue.departmentNames" multiple></wt-selector>
      </pt-form-list-item>
    </table>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import primaryOrganizationSelector from 'cps/selector/primary-organization-selector.vue'
// 组件class前缀
const prefixCls = 'pt-system-customer-form'

export default {
  name: 'pt-system-customer-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components:{
    primaryOrganizationSelector
  },
  props: {
    organizations: {
      type: Array,
      default: function () {
        return []
      }
    },
    userDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    rolesList: {
      type: Array,
      default: function () {
        return []
      }
    },
    offices: {
      type: Array,
      default: function () {
        return []
      }
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$store.state.menuList': {
      handler: function (val) {
        this.menuList = val
      },
      immediate: true
    },
    userDetail: {
      handler: function (val) {

        this.formValue = { ...val, ...val.organizationUser }
      }
    }
  },
  data () {
    return {
      formValue: {
        gender:'MALE'
      },
      menuList: [],
      ogranizationProp: {
        value: 'id',
        label: 'displayName'
      },
      roleProp: {
        value: 'id',
        label: 'displayName'
      },
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.menu-permissions {
  // margin-bottom: 20px;
  line-height: 40px;
}
.pt-system-customer-form {
  table {
    padding: 0 20px;
  }
}
.role-customer-basic-message {
  max-width: 500px;
  :global{
    .el-select{
      width: 100%;
    }
  }
}
.org-select {
  width: 100%;
}
.edit-password-text {
  color: red;
  font-size: 12px;
}
</style>
